import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import CardHeader from '../../Common/CardHeader';
import { cardStyles, PROFILER_IMAGES } from '../../Common/constants';
import { ProfilerQuestionID } from '../../config/QuestionEnum';
import { getQuestionConfig } from '../../config/questionsConfig';
const questionConfig = getQuestionConfig(ProfilerQuestionID.FMCG_FROZEN_FOODS);

const RefrigeratedUnits = ({
  questionId = ProfilerQuestionID.FMCG_FROZEN_FOODS,
  title = questionConfig?.question,
  value,
  defaultValue = '',
  onChange,
  onSubmit,
  submitLabel = 'Submit',
  options = questionConfig?.options || [],
}) => {
  const isControlled = typeof value === 'string';
  const [internalValue, setInternalValue] = useState(defaultValue);
  const selectedValue = isControlled ? value : internalValue;

  const handleSelect = (nextValue) => {
    if (!isControlled) {
      setInternalValue(nextValue);
    }
    onChange?.(nextValue);
  };

  const handleSubmit = () => {
    onSubmit?.({
      question: [
        { id: questionId, value: selectedValue }
      ]
    });
  };

  return (
    <Box sx={cardStyles()}>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between'}}>
        <CardHeader title={title} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, }}>
          <Box
            component='img'
            alt='Refrigerated units'
            width={180}
            sx={{ alignSelf: 'center' }}
            src={PROFILER_IMAGES.fridge}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {options.map((option) => {
              const isSelected = selectedValue === option.value;

              return (
                <CustomButton
                  key={option.value}
                  label={option.label}
                  variant={isSelected ? 'filled' : 'outlined'}
                  onClick={() => handleSelect(option.value)}
                  sx={{ width: '100%' }}
                  size='small'
                />
              );
            })}
          </Box>
          <CustomButton
            size='small'
            label={submitLabel}
            onClick={handleSubmit}
            disabled={!selectedValue}
            sx={{ width: '100%', mt: 'auto' }}
          />
          </Box>
        </Box>
    </Box>
  );
};

export default RefrigeratedUnits;
